<div class="db-optimization">
  <div class="db-optimization-content mb30">
    <div class="db-optimization-header mb4">Full website optimization with 10Web Hosting and Booster</div>
    <div class="db-optimization-desc" [innerHTML]="'text_optimizationWithBoosterAndHosting'| dbText"></div>
  </div>

  <div class="db-optimization-features mb50">

    <div class="db-optimization-left">
      <div *ngFor="let feature of features; let i=index">
        <div (click)="toggleArrow(i)">
          <i class="db-icon db-icon-ds-arrow-small arrow mr13" [ngClass]="{'rotate': showDesc === i}"></i>
          <span [ngClass]="{'toggled': showDesc === i}" [innerHTML]="feature.title"></span>
        </div>
        <div class="db-desc pl13"  [ngClass]="{'toggled': showDesc === i}">
          <p class="ml26" [innerHTML]="feature.desc"></p>
        </div>
      </div>
    </div>

    <div class="db-optimization-right"  *ngFor="let feature of features; let i=index"  [ngClass]="{'toggled': showDesc === i}">
      <img *ngIf="showDesc === i" class="ml10 mt40" src="{{feature.img}}" alt="">
    </div>
  </div>
  <button class="ds-btn-green ds-btn-m" [routerLink]="['/upgrade-plan']"><span>Upgrade</span>
  </button>
</div>
